import { lazy } from "react";
import Loadable from "app/components/Loadable";

const AccessControl = Loadable(lazy(() => import("./AccessControl")));

const AccessControlRoutes = [
  { path: "/access/control", element: <AccessControl /> },
];

export default AccessControlRoutes;
